import React from 'react';
import { CarTypesData } from 'AppClient/api/BookingExternalDictionaries';
import classnames from 'classnames';
import { VehicleIcon } from 'AppClient/components/VehicleIcon';
import { ThemeContext } from 'app-themes';

import styles from './styles.module.scss';

interface Props {
	carData: CarTypesData;
	onSelect: (carTypeId: number | string) => void;
	selectedId: number | string | null;
}
const VehicleTab: React.FC<Props> = props => {
	const { carData, onSelect, selectedId } = props;
	const { carTypeName, passengerCapacity, carTypeId } = carData;
	const isSelected = carTypeId === selectedId;
	return (
		<ThemeContext.Consumer>
			{(theme: string) => (
				<div
					onClick={() => onSelect(carTypeId)}
					className={classnames(styles.vehicle, {
						active: isSelected,
						[styles[`vehicle-${theme}`]]: theme !== '',
					})}
				>
					<div className={styles.vehicleWrapper}>
						<VehicleIcon carTypeName={carTypeName} />
						<span className={styles.vehicleType}>{carTypeName}</span>
						<span className={styles.vehiclePass}>up to {passengerCapacity} pass</span>
						<input type="hidden" value="standard" />
					</div>
				</div>
			)}
		</ThemeContext.Consumer>
	);
};

export default VehicleTab;
